var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "trade-mining-wrapper" },
    [
      _c(
        "sec-title",
        {
          attrs: { isShowHelp: false, title: _vm.$t("tradeMining.todayTrade") }
        },
        [
          _c(
            "span",
            { staticClass: "link __pointer", on: { click: _vm.goView } },
            [_vm._v(_vm._s(_vm.$t("tradeMining.view")))]
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "tab_title" }, [
        _c(
          "div",
          {
            staticClass: "tab_title_item",
            class: { active: _vm.tabName === "trade" },
            on: {
              click: function($event) {
                _vm.tabName = "trade"
              }
            }
          },
          [
            _c("span", { staticClass: "tab_img trade" }),
            _vm._v(" "),
            _c("div", [
              _c(
                "div",
                { staticClass: "label" },
                [
                  _vm._v(
                    _vm._s(_vm.$t("tradeMining.txTitle")) +
                      "\n                    "
                  ),
                  _c("help-tips", {
                    attrs: { helpText: _vm.$t("tradeMining.help") }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "amount" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm._f("formatNum")(_vm.tradeMiningTotal)) +
                    " dSLS\n                "
                )
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "gap" }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "tab_title_item",
            class: { active: _vm.tabName === "staking" },
            on: {
              click: function($event) {
                _vm.tabName = "staking"
              }
            }
          },
          [
            _c("span", { staticClass: "tab_img staking" }),
            _vm._v(" "),
            _c("div", [
              _c("div", { staticClass: "label" }, [
                _vm._v(_vm._s(_vm.$t("tradeMining.quotaTitle")))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "amount" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm._f("formatNum")(_vm.stakingMiningTotal)) +
                    " dSLS\n                "
                )
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "gap" }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "tab_title_item",
            class: { active: _vm.tabName === "invite" },
            on: {
              click: function($event) {
                _vm.tabName = "invite"
              }
            }
          },
          [
            _c("span", { staticClass: "tab_img invite" }),
            _vm._v(" "),
            _c("div", [
              _c("div", { staticClass: "label" }, [
                _vm._v(_vm._s(_vm.$t("inviteMining.title")))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "amount" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm._f("formatNum")(_vm.inviteMiningTotal)) +
                    " dSLS\n                "
                )
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "gap" }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "tab_title_item",
            class: { active: _vm.tabName === "order" },
            on: {
              click: function($event) {
                _vm.tabName = "order"
              }
            }
          },
          [
            _c("span", { staticClass: "tab_img order" }),
            _vm._v(" "),
            _c("div", [
              _c("div", { staticClass: "label" }, [
                _vm._v(_vm._s(_vm.$t("orderMining.title")))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "amount" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm._f("formatNum")(_vm.orderMiningTotal)) +
                    " dSLS\n                "
                )
              ])
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _vm.tabName === "trade" ? _c("tradeMinComp") : _vm._e(),
      _vm._v(" "),
      _vm.tabName === "staking" ? _c("stakingMinComp") : _vm._e(),
      _vm._v(" "),
      _vm.tabName === "invite" ? _c("inviteMinComp") : _vm._e(),
      _vm._v(" "),
      _vm.tabName === "order" ? _c("orderMinComp") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }